var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sso-btn",on:{"click":_vm.ssoButtonClicked}},[_c('v-img',{attrs:{"contain":"","src":_vm.imageSrc}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.buttonText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }